import { FC, useEffect, useState } from "react";
import AttributeForm from "./attributeForm";
import HierarchyForm from "./hierarchyForm";
import MeasurementsClothingForm from "./measurementsClothingForm";
import MeasurementsForm from "./measurementsForm";
import QueryForm from "./queryForm";
import { useSelector } from "react-redux";
import { ProductFormProps } from "../../../Types/Product/ProductFormProps";
import {
  IInitialStateProduct,
  iInitialStateProduct,
} from "../../../Interfaces/Product/IProduct";
import FoodVolumetricsForm from "./foodVolumetricsForm";
import { ProductValueType } from "../../../Types/Product/ProductValueType";
import { VolumetricsReviewDataModel } from "../../../Types/Product/VolumetricsReviewDataModel";

const ProductEditForm: FC<ProductFormProps> = (props) => {
  const [product, setProduct] = useState<IInitialStateProduct>(iInitialStateProduct);
  const [selectedMenu, setSelectedMenu] = useState();
  const payload = useSelector((state: any) => state.popupReducer);
  const selectedMenuFromFilterReducer = useSelector(
    (state: any) => state.filterReducer.data
  );
  const menuFromMenuHeaderReducer = useSelector(
    (state: any) => state.menuHeaderReducer?.data
  );

  //To get correct menu as per the condition
  useEffect(() => {
    if (
      menuFromMenuHeaderReducer !== null &&
      !menuFromMenuHeaderReducer?.isDirectQuery &&
      !selectedMenuFromFilterReducer.isDirectQuery
    ) {
      setSelectedMenu(menuFromMenuHeaderReducer.selectedMenu);
    } else {
      setSelectedMenu(selectedMenuFromFilterReducer?.selectedMenu);
    }
  }, [menuFromMenuHeaderReducer, selectedMenuFromFilterReducer]);

  useEffect(() => {
    if (payload.data) {
      const editPayloadValue = payload.data.editPayload;
      if (editPayloadValue?.values && 'sainId' in editPayloadValue.values) {
        setProduct(editPayloadValue);
      }
    } else {
      setProduct(iInitialStateProduct);
    }
  }, []);

  const { values } = product;
  return (
    <>
      {selectedMenu === "Attributes" && (
        <AttributeForm
          onSubmit={props.onSubmit}
          onChange={props.onChange}
          onClearAll={props.onClearAll}
          onCancel={props.onCancel}
          onBlur={props.onBlur}
          errors={props.errors}
          values={props.values}
        />
      )}
      {selectedMenu === "Hierarchy" && (
        <HierarchyForm
          onSubmit={props.onSubmit}
          onChange={props.onChange}
          onClearAll={props.onClearAll}
          onCancel={props.onCancel}
          onBlur={props.onBlur}
          errors={props.errors}
          values={values}
        />
      )}
      {selectedMenu === "Measurements-Clothing" && (
        <MeasurementsClothingForm
          onSubmit={props.onSubmit}
          onChange={props.onChange}
          onClearAll={props.onClearAll}
          onCancel={props.onCancel}
          onBlur={props.onBlur}
          errors={props.errors}
          values={values}
        />
      )}
      {selectedMenu === "Measurements" && (
        <MeasurementsForm
          onSubmit={props.onSubmit}
          onChange={props.onChange}
          onClearAll={props.onClearAll}
          onCancel={props.onCancel}
          onBlur={props.onBlur}
          errors={props.errors}
          values={props.values}
          dirty={props.dirty}
          warnings={props.warnings}
        />
      )}
      {selectedMenu === "Query" && (
        <QueryForm
          onSubmit={props.onSubmit}
          onChange={props.onChange}
          onClearAll={props.onClearAll}
          onCancel={props.onCancel}
          onBlur={props.onBlur}
          errors={props.errors}
          values={props.values}
          dirty={props.dirty}
        />
      )}
      {selectedMenu === "Food Volumetrics" && (
        <FoodVolumetricsForm
          onSubmit={props.onSubmit}
          onChange={props.onChange}
          onClearAll={props.onClearAll}
          onCancel={props.onCancel}
          onBlur={props.onBlur}
          errors={props.errors}
          values={props.values as VolumetricsReviewDataModel}
          dirty={props.dirty}
          warnings={props.warnings}
        />
      )}
    </>
  );
};

export default ProductEditForm;
